
import { ListDataSource } from "@/data/List/ListDataSource";
import { Vue, Component, Watch } from "vue-property-decorator";
import ObjectDataTable from "@/components/helpers/object-data-table.vue";
import {
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiMinus,
  mdiPen,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiTrashCan,
} from "@mdi/js";
import editor from "./editor";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import _ from "lodash";

@Component({
  mixins: [editor],
  components: { ObjectDataTable },
})
export default class ProductLinkInlineEditor extends Vue {
  dataSource!: ObjectDataSource;
  searchTimer: any = null;
  dialog: boolean = false;
  searchText: string = "";
  filterText: string = "";
  loaded: boolean = false;
  personListCopy: any = [];
  icons: any = {
    plus: mdiPlus,
    minus: mdiMinus,
    pen: mdiPen,
    trash: mdiTrashCan,
    search: mdiMagnify,
    dotsVertical: mdiDotsVertical,
    circlePlus: mdiPlusCircleOutline,
    folderOpen: mdiFolderOpen,
    folder: mdiFolder,
  };

  headers: any[] = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Подпись",
      value: "caption",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  public get fieldName() {
    return this.field?.config?.fieldName ?? "persons";
  }

  public get sourceObjectFieldName() {
    return this.field?.config?.sourceObjectFieldName ?? "companyBranchId";
  }

  field!: any;
  personDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: this.field?.config?.className ?? "person",
  });

  linkedPersonDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: this.field?.config?.className ?? "person",
  });
  companyBranchPersonDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: this.field?.config?.linkedClassName ?? "companyBranchPerson",
  });

  $message: any;

  updatePersons() {
    let sourceItems = Array.from([...this.personDataSource.items]);

    for (const person of sourceItems) {
      const exists = this.dataSource.model?.[this.fieldName].some(
        (c: any) => c.personId == person.id,
      );
      if (exists) {
        const index = this.personDataSource.items.findIndex(
          (c: any) => c.id == person.id,
        );
        this.personDataSource.items.splice(index, 1);
      }
    }
    this.linkedPersonDataSource.items = this.dataSource.model?.[this.fieldName]?.map(
      (cf: any) => this.personListCopy.find((f: any) => f.id == cf.personId),
    );
  }

  filterLinkedperson() {
    this.updatePersons();
    if (!this.filterText) return;
    const re = new RegExp(this.filterText, "gi");
    this.linkedPersonDataSource.items =
      this.linkedPersonDataSource.items.filter((c: any) => c.caption.match(re));
  }

  async created() {

    await this.personDataSource.get();

    this.personListCopy = _.cloneDeep(this.personDataSource.items);
    this.linkedPersonDataSource.metadata = this.personDataSource.metadata;
    this.linkedPersonDataSource.total = this.dataSource.model?.[this.fieldName]?.length;
    this.companyBranchPersonDataSource.items = this.dataSource.model?.[this.fieldName];
    this.updatePersons();
    this.loaded = true;
  }

  async add(item: any) {
    await this.companyBranchPersonDataSource.add({
      [this.sourceObjectFieldName]: this.dataSource.id,
      personId: item.id,
    });

    await this.dataSource.get();
    this.updatePersons();
    this.linkedPersonDataSource.total =
      this.linkedPersonDataSource.items.length;
    this.$message("Успешно добавлено");
  }

  async remove(item: any) {
    const cf = this.dataSource.model?.[this.fieldName]?.find(
      (c: any) => c.personId == item.id,
    );
    await this.companyBranchPersonDataSource.remove(cf.id);
    const index = this.linkedPersonDataSource.items.findIndex(
      (c: any) => c.id === item.id,
    );
    if (index === -1) throw new Error("не найден");
    this.linkedPersonDataSource.items.splice(index, 1);
    this.personDataSource.items.push(item);
    this.linkedPersonDataSource.total = this.linkedPersonDataSource.items.length;

    this.$message("Успешно удалено");
  }

  @Watch("searchText")
  debounceSearch(value: string) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(async () => {
      this.personDataSource.config.filter = JSON.stringify([
        {
          fieldName: "searchText",
          fieldValue: value,
        },
      ]);
      await this.personDataSource.get();
      this.updatePersons();
    }, 1000);
  }
}
